module.exports = __webpack_public_path__ + "img/header.3f32d2cf.jpg";